// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fb295ea2","453":"27ebff64","455":"88415d06","977":"d1b2d7ef"}[chunkId] + ".chunk.js";
};